// extracted by mini-css-extract-plugin
export var container = "Timeline-module--container--83c31";
export var imageDescription = "Timeline-module--image-description--a8a85";
export var section = "Timeline-module--section--72a98";
export var summary = "Timeline-module--summary--37b1a";
export var timeline = "Timeline-module--timeline--4254d";
export var title = "Timeline-module--title--c2b63";